<template>
  <AllegroJsonForm
    title="Allegro - Konfiguracja OAuth"
    crumbLabel="Dodaj OAuth"
    :settingsCrumb="true"
    submitAction="createAllegroOauth"
    submitGetter="getAllegroOauthCreateData"
    backRoute="/allegro/accounts"
    successRoute="/allegro/accounts/:pk/overview"
    accountPkParam="pk"
    :modelPermission="modelPermission"
    :fields="fields"
    :emptyObjects="['user_agent']"
  />
</template>

<script>
import AllegroJsonForm from "./AllegroJsonForm.vue";
import { allegroConfigPermissionsConst } from "../../constants/allegroConstants";

export default {
  name: "AllegroOauthCreate",
  components: { AllegroJsonForm },
  data() {
    return {
      modelPermission: allegroConfigPermissionsConst.add,
      fields: [
        {
          key: "user_agent.app_name",
          label: "Nazwa aplikacji",
          required: true,
        },
        {
          key: "user_agent.app_version",
          label: "Wersja aplikacji",
          required: true,
        },
        {
          key: "user_agent.url",
          label: "Adres strony kontaktowej",
          required: true,
        },
        { key: "client_id", label: "Client ID", required: true },
        { key: "client_secret", label: "Client secret", required: true },
        { key: "base_url", label: "Adres do autoryzacji", required: true },
        { key: "base_api_url", label: "Adres do API", required: true },
      ],
    };
  },
};
</script>
